const AddIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="m7.3999 13h10v1.2h-10z"
          transform="matrix(0 -1 1 0 -5.6001 20.3999)"
        />
        <path d="m3 7.3999h10v1.2h-10z" />
      </g>
    </svg>
  );
};
export default AddIcon;
